export default {
  namespaced: true,
  //
  state: {
    page: "home"
  },
  //
  mutations: {
    setPage(state, name) {
      state.page = name;
    }
  },
  //
  actions: {}
};



// WEBPACK FOOTER //
// ./src/store/modules/cabinet.js